import jinjaToJS from "jinja-to-js";export default function templateModulesCalloutsSaveForLaterCallout(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    __result += "<div class=\"save-for-later-callout\" is=\"save-for-later-callout\">\n\n    <h5 class=\"save-for-later-callout__title mb5\">\n        <i class=\"glyph glyph-tick\"></i>\n        Saved for a rainy day\n    </h5>\n\n    <div class=\"save-for-later-callout__text mb10\">View saved items in your profile any time.</div>\n\n    <button class=\"save-for-later-callout__button btn btn-secondary btn--full-width\">\n        ok, got it\n    </button>\n\n</div>";
    return __result;
}